module.exports = __webpack_public_path__ + "static/media/buy_report_service_5-1.bdd6a7a4.png";